import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { TRANSCRIPT_COMPLETE_PARAGRAPH_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { vendorSaveTranscriptParagraphFileFailure, vendorSaveTranscriptParagraphFileSuccess } from '../actions';

const VendorCompleteParagraphAPI = (action) => postApiRequest(TRANSCRIPT_COMPLETE_PARAGRAPH_API_URL, action);

function* handleVendorCompleteParagraph(action) {
  try {
    const response = yield call(VendorCompleteParagraphAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(vendorSaveTranscriptParagraphFileSuccess(response));
  } catch (error) {
    yield put(vendorSaveTranscriptParagraphFileFailure(error));
  }
}

export function* watchVendorCompleteParagraph() {
  yield takeLatest(types.TRANSCRIPT_COMPLETE_PARAGRAPH_REQUEST, handleVendorCompleteParagraph);
}
